import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/contact_reasons'),
      component: SettingsWrapper,
      children: [
        {
          path: 'list',
          name: 'contact_reasons_list',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.CONTACT_REASONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
